import { SerializedStyles, css } from "@emotion/react";
import styled from "@emotion/styled";
import { colors } from "goi_common";
import { HTMLAttributes } from "react";

type ButtonSize = "small" | "medium" | "large";

interface Props extends HTMLAttributes<HTMLButtonElement> {
  size: ButtonSize;
  fullWidth?: boolean;
}

const OutlinedButton = (props: Props) => {
  const { size, fullWidth, children, ...rest } = props;

  return (
    <StyledButton size={size} {...rest} fullWidth={fullWidth}>
      {children}
    </StyledButton>
  );
};

export default OutlinedButton;

const BUTTON_SIZE_STYLE: { [key in ButtonSize]: SerializedStyles } = {
  small: css`
    padding: 12px 16px;
  `,
  medium: css`
    padding: 18px 0;
  `,
  large: css`
    padding: 37px 0;
  `,
};

interface StyledButtonProps {
  size: ButtonSize;
}

const StyledButton = styled.button<Props>`
  ${(props) => BUTTON_SIZE_STYLE[props.size]};

  border: 1px solid ${colors.gray700};
  border-radius: 10px;

  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
`;
